import React from 'react';
import StageForm from '../../../components/stage/stage-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as stagesActions from '../../../actions/stages';
import * as distanceActions from '../../../actions/admin/distance-actions';
import DistanceModal from '../../../components/stage/distance-modal';
import Loading from '../../../components/loading';
import AdminItemPageContainer from '../admin-item-page-container';
import LocalizedStrings from '../../../localization/strings';
import { translateAPIResponse } from '../../../utils/form';

class StageContainer extends AdminItemPageContainer {

    getBaseUrl() {
        return '/admin/stages';
    }

    fetchItem(id) {
        return this.props.actions.fetchStage(id)
    }

    editDistance(distance) {
        this.props.actions.toggleDistanceModal(true, distance);
    }

    removeDistance(distance) {
        if (confirm(LocalizedStrings.doYouWantToRemove)) {
            this.props.actions.removeDistance(distance).then(translateAPIResponse).catch((err) => {
                alert(err)
            });
        }
    }

    renderDistances() {
        const {stage} = this.props;
        if (!stage.distances) {
            return null;
        }
        return (
            <div className="panel">
                <header className="panel-header">{LocalizedStrings.distanceEdit}</header>
                <div className="panel-body">                <div className="table-actions-row">

                    <a className="btn btn-primary " onClick={() => {
                        this.editDistance({stageId: stage.id});
                    }}>{LocalizedStrings.newDistance}</a></div>
                    <table className="table responsive">
                        <thead>
                        <tr>
                            <td>{LocalizedStrings.name}</td>
                            <td>{LocalizedStrings.code}</td>
                            <td>{LocalizedStrings.isFree}</td>
                            <td>{LocalizedStrings.actions}</td>
                        </tr>
                        </thead>
                        <tbody>
                            {stage.distances.map(distance => {
                                return <tr key={`${distance.id}-distance`}>
                                    <td>{distance.name}</td>
                                    <td>{distance.code}</td>
                                    <td>{distance.isFree ? LocalizedStrings.yes : LocalizedStrings.no}</td>
                                    <td>
                                        <div className="btn-group">
                                            <a className="btn" onClick={() => {
                                                this.editDistance(distance)
                                            }}>{LocalizedStrings.edit}</a>

                                            <a onClick={() => {
                                                this.removeDistance(distance)
                                            }} className="btn btn-red">{LocalizedStrings.remove}</a>
                                        </div>

                                    </td>
                                </tr>
                            })}
                        </tbody>
                    </table>

                </div>
            </div>
        )
    }

    closeDistanceModal() {
        this.props.actions.toggleDistanceModal(false);
    }

    onDistanceSuccessSubmit(wasNew, distance) {
        this.closeDistanceModal();
        this.props.actions.updateStageDistance(distance);
    }
    render() {
        const {actions, loading, stage, distanceModal} = this.props;

        return (
            <div>
                <div className="panel">
                    <header className="panel-header">{LocalizedStrings.stageEdit}</header>
                    {loading
                        ? <Loading/>
                        : (
                            <div className="panel-body">
                                <StageForm submit={actions.submitStage} onSuccessSubmit={this.onSuccessSubmit.bind(this)}></StageForm>

                            </div>
                        )}
                </div>
                {stage
                    ? this.renderDistances()
                    : null}
                <DistanceModal isOpen={distanceModal} stage={stage} submit={actions.submitDistance} cancel={this.closeDistanceModal.bind(this)} onSuccessSubmit={this.onDistanceSuccessSubmit.bind(this)}/>
            </div>

        )
    }
}

export default connect(function(state) {
    return {loading: state.stage.stage.loading, stage: state.stage.stage.item, distanceModal: state.distance.distance_modal};
}, function(dispatch) {
    return {
        actions: bindActionCreators({
            ...stagesActions,
            ...distanceActions
        }, dispatch)
    };
})(StageContainer);



// WEBPACK FOOTER //
// ./src/js/containers/admin/stage/stage-container.js